import { uniq } from "lodash";
import { useMemo } from "react";
import useClientDashboard from "./useClientDashboard";
/**
 * @returns All custodians a client has accounts open with
 */
export default function useAllClientCustodians(clientId, authConfig) {
    const dashboard = useClientDashboard(clientId, authConfig);
    const result = useMemo(() => {
        if (dashboard.isLoading || dashboard.hasError) {
            return dashboard;
        }
        const allCustodians = dashboard.data.accountDetails.map((d) => d.accountDetails.custodian);
        const uniqueCustodians = uniq(allCustodians);
        return {
            data: uniqueCustodians,
            isLoading: false,
            hasError: false,
            preFetch: dashboard.preFetch,
        };
    }, [dashboard]);
    return result;
}
//# sourceMappingURL=useAllClientCustodians.js.map